import React from "react";
import { Box, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";

import CCrud from "components/Molecules/Crud";
import Breadcrumb from "components/Atoms/SharedComponents/Breadcrumbs/Breadcrumb";
import MeritOrderDetails from "pages/merit/MeritOrderDetails";

function MeritOrdersTemplate({
  data,
  count,
  details,
  paginationPage,
  handlePageChange,
  rowData,
  breadcrumbs,
  filterList,
  actionsList,
  setFilterObj,
}) {
  const { t } = useTranslation();

  const columnData = [
    { accessor: "id", Header: t("merit_orders.col_id") },
    {
      accessor: "reference",
      Header: t("merit_orders.col_reference"),
      sort: true,
    },
    {
      accessor: "status_display",
      Header: t("merit_orders.col_status"),
    },
    {
      accessor: "amount_display",
      Header: t("merit_orders.col_amount"),
      sort: true,
    },
    {
      accessor: "customer_name_display",
      Header: t("merit_orders.col_customer"),
      sort: true,
    },
    {
      accessor: "customer_email_display",
      Header: t("merit_orders.col_email"),
    },
    {
      accessor: "gift_card_display",
      Header: t("merit_orders.col_gift_card"),
    },
    {
      accessor: "date",
      Header: t("merit_orders.col_date"),
      sort: true,
    },
    { accessor: "Actions", Header: t("merit_orders.actions") },
  ];

  return (
    <Box>
      <Stack
        direction="row"
        alignSelf="start"
        justifyContent="start"
        gap={2}
        width="100%"
      >
        <Breadcrumb data={breadcrumbs} />
      </Stack>
      <CCrud
        table={{
          list: data,
          listTitle: t("merit_orders.list_title"),
          columns: columnData,
          isSearch: false,
          isChecked: false,
          total_count: count,
          setFilterObj,
          className: "main-table",
          paginationPage,
          handlePageChange,
          rowData,
          filterList,
          actionsList,
          details,
        }}
        DetailsComponent={<MeritOrderDetails details={details} />}
      />
    </Box>
  );
}

export default MeritOrdersTemplate;
